module.exports = __webpack_public_path__ + "static/media/crepe.47de9623.svg";